const giftMessageContainer = document.querySelector('[data-gift-note-container]');
const giftMessageInput = document.querySelector('[data-cart-gift-message]');
const giftLearnMoreBtn = document.querySelector('[data-cart-gift-btn]');
const dialogEntry = document.querySelector('[data-dialog-entry]');

function buildGiftDialog() {
  dialogEntry.innerHTML = `
    <div class="cart-gift-dialog">
      <svg height="37.999" viewBox="0 0 28.245 37.999" width="28.245" xmlns="http://www.w3.org/2000/svg"><path d="m241.154 69.289a11.535 11.535 0 0 1 .407 5.417 18.431 18.431 0 0 1 -2.055 6.242 35.217 35.217 0 0 1 -3.915 6.023q-3.206 3.922-6.384 7.866l-.439.491-1.045 1.333c-.248.335-.539.636-.8.957a6.694 6.694 0 0 1 -.47.563 10.482 10.482 0 0 0 -1.509 1.788c-1.758 2.76-1.376 3.247-2.164 2.964l-.018-.006a1.253 1.253 0 0 1 -.532-1.895l1.687-2.392c.16-.214.327-.434.5-.653a3.422 3.422 0 0 1 -1.338-1.338c-.165-.277-.331-.554-.482-.838-.816-1.54-1.651-3.068-2.57-4.548-.667-1.074-1.262-2.192-1.872-3.3q-1.087-1.973-2.156-3.955a23.069 23.069 0 0 1 -2.358-6.512 9.215 9.215 0 0 1 .446-5.153 4.962 4.962 0 0 1 .627-1.156c1.258-1.714 3.285-2.1 5.582-1a8.369 8.369 0 0 1 3.294 2.949 11.512 11.512 0 0 1 1.546 3.117 1.286 1.286 0 0 0 .11.188c.324-.992.6-1.926.934-2.841.3-.828.637-1.643.989-2.45a12.564 12.564 0 0 1 3.435-4.525 6.561 6.561 0 0 1 6.236-1.364 5.942 5.942 0 0 1 4.314 4.028zm-1.863 3.148a10.006 10.006 0 0 0 -.559-3.706 4.663 4.663 0 0 0 -1.37-2.054 2.809 2.809 0 0 0 -2.13-.686 5.115 5.115 0 0 0 -2.849 1.185 11.568 11.568 0 0 0 -3.322 4.058c-.542 1.167-1.036 2.36-1.48 3.568a33.374 33.374 0 0 0 -1.488 5.623c-.07.389-.168.457-.554.45a1.332 1.332 0 0 1 -1.3-1.045c-.233-.984-.45-1.972-.7-2.952a12.4 12.4 0 0 0 -2.289-4.455 6.245 6.245 0 0 0 -2.033-1.659 1.424 1.424 0 0 0 -1.529.048 3.774 3.774 0 0 0 -.581.446 3.7 3.7 0 0 0 -1.015 1.759 9.43 9.43 0 0 0 .026 5.408 29.685 29.685 0 0 0 2.456 6.067c1.18 2.107 2.3 4.248 3.515 6.334 1.034 1.777 2.147 3.508 3.024 5.373.074.157.172.3.287.5.116-.138.21-.245.3-.351l.159-.2c2.468-3.194 4.917-6.4 7.409-9.578a37.46 37.46 0 0 0 4.042-6.519 18.494 18.494 0 0 0 1.982-7.615z" fill="#f0b79c" transform="translate(-213.456 -65.004)"/><path d="m292.873 92.167a10.005 10.005 0 0 1 .559 3.706 18.494 18.494 0 0 1 -1.982 7.615 37.465 37.465 0 0 1 -4.042 6.519c-2.491 3.176-4.941 6.384-7.409 9.578l-.159.2c-.087.106-.181.213-.3.351-.115-.2-.213-.344-.287-.5-.877-1.865-1.99-3.6-3.024-5.373-1.214-2.086-2.334-4.227-3.515-6.334a29.684 29.684 0 0 1 -2.456-6.067 9.43 9.43 0 0 1 -.026-5.408 3.7 3.7 0 0 1 1.015-1.759 3.774 3.774 0 0 1 .581-.446 1.424 1.424 0 0 1 1.529-.048 6.246 6.246 0 0 1 2.033 1.659 12.4 12.4 0 0 1 2.289 4.455c.247.98.464 1.968.7 2.952a1.332 1.332 0 0 0 1.3 1.045c.386.008.484-.061.554-.45a33.369 33.369 0 0 1 1.488-5.623c.444-1.208.938-2.4 1.48-3.568a11.568 11.568 0 0 1 3.322-4.058 5.115 5.115 0 0 1 2.849-1.185 2.809 2.809 0 0 1 2.13.686 4.663 4.663 0 0 1 1.371 2.053z" fill="#fff" transform="translate(-267.596 -88.44)"/></svg>
      <div>This Order Is A Gift, We Promise To Make It Special…</div>
      <p>Drop a note for your gift recipient in the box below and they will receive a handwritten card with your message and a beautiful box, carefully wrapped with love. Don’t worry, no receipt will be included in their special delivery. Thank you for sharing the love of PRFCT!</p>
    </div>
  `;
  showDialog();
}

document.addEventListener('DOMContentLoaded',() => {

  function updateLinePrice(cart,index) {
    var zeroIndex = index - 1;
    var linePrice = cart.items[zeroIndex].line_price / 100;
    linePrice = linePrice.toFixed(2);
    $('[data-line-price-' + index + ']').text('$' + linePrice);
  }

  $("[data-minus-index]").on('click',function() {
    var $self = $(this);
    var lineIndex = $(this).data('minus-index');
    var currentQty = $('[data-line-qty-' + lineIndex + ']').val();
    var newQty = --currentQty;
    if (newQty < 0) return;
    $('[data-line-qty-' + lineIndex + ']').val(newQty);
    CartJS.updateItem(lineIndex, newQty, {}, {
      "success": function(data, textStatus, jqXHR) {
        if (newQty === 0) {
          if (data.item_count === 0) {
            window.location.reload();
            return;
          }
          $self.closest('.cart-line-item').hide();
          return;
        }
        updateLinePrice(data,lineIndex);
      }
    });
  });

  $("[data-plus-index]").on('click',function() {
    var variantQtyLimit = this.dataset.variantQtyLimit;
    var lineIndex = $(this).data('plus-index');
    var currentQty = $('[data-line-qty-' + lineIndex + ']').val();
    if (variantQtyLimit && typeof variantQtyLimit !== undefined && Number(variantQtyLimit) >= Number(currentQty)) return;
    $('[data-line-qty-' + lineIndex + ']').val(++currentQty);
    var newQty = currentQty;
    CartJS.updateItem(lineIndex, newQty, {}, {
      "success": function(data, textStatus, jqXHR) {
        updateLinePrice(data,lineIndex);
      }
    });
  });

  function dataLayerRemove(id,name,price,category,qty,productId) {
    dataLayer.push({
      'event': 'Remove From Cart',
      'logged_in': pf_api.customer.loggedIn,
      'category': 'Conversion Funnel',
      'label': 'Remove From Cart',
      'page_path': window.location.pathname,
      'site_version': pf_api.siteVersion,
      'name': name,
      'id': productId,
      'price': price,
      'ecommerce': {
      'currencyCode':'USD',
      'remove': {
          'products': [
            {
              'id': id,
              'name': name,
              'price': price,
              'brand': 'PRFCT',
              'category': category,
              'quantity': qty
            }
          ]
        }
      }
    });
  }

  $('[data-remove-line-item]').on('click',function() {
    var $lineItem = $(this).closest('.cart-line-item');
    var indexToRemove = $(this).data('remove-line-item');
    var qty = $lineItem.find('.qty-total').val();
    var product = $lineItem.attr('data-line-product');
    var id = $lineItem.attr('data-line-id');
    var type = $lineItem.attr('data-line-type');
    var price = $lineItem.attr('data-line-price');
    var productId = $lineItem.attr('data-line-product-id');
    CartJS.removeItem(indexToRemove, {
      "success": function(data, textStatus, jqXHR) {
        dataLayerRemove(id,product,price,type,qty,productId)
        window.location.reload();
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        alert('Woops! Please try again.');
      }
    });
  });

  function setGiftNote() {
    var message = $('[data-cart-note]').val();
    CartJS.setNote(message, {});
  }

  document.querySelectorAll('[data-cart-frequency-select]').forEach(select => select.addEventListener('change', function(event) {
    const selectedPlan = event.currentTarget.value;
    const key = event.currentTarget.dataset.lineItem;
    const qty = event.target.dataset.lineItemQuantity;
    console.info('qty',qty);

    $.ajax({
      type: 'POST',
      url: window.pf_api.routes.cart_change_url,
      data: 'selling_plan='+selectedPlan+'&id=' + key + '&quantity=' + qty,
      dataType: 'json',
      success: () => window.location.reload()
    });
  }));

  $('[data-cart-note]').on('input',_throttle(function() {
    setGiftNote();
  }, 750));

  $('[data-cart-gift-note-input]').on('change',function() {
    CartJS.setAttribute('This is a gift', this.checked ? 'Yes': '' );
    giftMessageContainer.style.display = this.checked ? 'block' : 'none';
    if (!this.checked) {
      CartJS.setAttribute('Gift message', '');
    } else {
      CartJS.setAttribute('Gift message', giftMessageInput.value);
    }
  });

  giftMessageInput.addEventListener('input',_throttle(function(event) {
    CartJS.setAttribute('Gift message', this.value.trim().length > 0 ? this.value : '');
  }, 750));

  giftLearnMoreBtn.addEventListener('click',() => {
    buildGiftDialog();
  });
  
});